import { render, staticRenderFns } from "./Advices.vue?vue&type=template&id=60e1832b&scoped=true&"
import script from "./Advices.vue?vue&type=script&lang=js&"
export * from "./Advices.vue?vue&type=script&lang=js&"
import style0 from "./Advices.vue?vue&type=style&index=0&id=60e1832b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e1832b",
  null
  
)

export default component.exports